import type { BookingChannel } from '#components/Autocomplete/BookingChannels/BookingChannelsAutocomplete.types.ts';

import { BookingChannelsAutocomplete } from '#components/Autocomplete/BookingChannels/BookingChannelsAutocomplete.tsx';
import { bookingOptions } from '#components/Autocomplete/BookingChannels/BookingChannelsAutocomplete.utils.ts';
import { useFilterAutocomplete } from './use-filter-autocomplete.ts';

export function BookingChannel(props: { defaultValue: BookingChannel['id'][] }) {
  const filterAutocomplete = useFilterAutocomplete({
    searchParamKey: 'bcId',
    defaultValue: props.defaultValue,
    data: bookingOptions,
  });

  return (
    <BookingChannelsAutocomplete
      inputLabel="Booking Channel"
      {...filterAutocomplete.getAutocompleteProps()}
    />
  );
}
